import { Button } from '@acpaas-ui/react-components';
import StaticTable from '../../containers/core/StaticTable';
import { PROCEDURE_STAKEHOLDERS_RESOURCE } from '../../resources/procedure.stakeholders.resource';
import EmailStakeholdersAction from '../stakeholders/EmailStakeholdersAction';

const DossierProcedureStakeholders = ({ involved = [], write, onStakeholderAdd, onStakeholderOpen }) => {
  return (
    <StaticTable
      resource={PROCEDURE_STAKEHOLDERS_RESOURCE}
      onRowClick={onStakeholderOpen}
      data={involved}
      actions={
        write
          ? [
              <EmailStakeholdersAction key="stakeholder-email" className="u-margin-right-sm" stakeholders={involved} />,
              <Button
                key="stakeholder-add"
                size="small"
                className="u-margin-right-sm"
                iconRight="ai-add"
                onClick={onStakeholderAdd}
              >
                Betrokkene toevoegen
              </Button>
            ]
          : [<EmailStakeholdersAction key="stakeholder-email" className="u-margin-right-sm" stakeholders={involved} />]
      }
      responsive
    />
  );
};

export default DossierProcedureStakeholders;
